import { render, staticRenderFns } from "./ph-academy-videos.vue?vue&type=template&id=a6ff0154"
import script from "./ph-academy-videos.vue?vue&type=script&lang=js"
export * from "./ph-academy-videos.vue?vue&type=script&lang=js"
import style0 from "./ph-academy-videos.vue?vue&type=style&index=0&id=a6ff0154&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports